










import { defineComponent } from "@vue/composition-api";
import { isTipMessageDetails, TipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "MessagePreviewTip",
  components: { FormatMoney },
  props: {
    message: { type: Object as () => Message, required: true },
    isOpponentMessage: { type: Boolean, required: true },
  },
  computed: {
    details(): TipMessageDetails | null {
      return isTipMessageDetails(this.message.details) ? this.message.details : null;
    },
  },
});
